const getErrorDetail = (text) => {
    if (!text) return "";
    const parts = text.split(":");
    return parts.length > 1 ? parts.slice(1).join(":").trim() : text.trim();
};


const parseExtrasErrors = (extrasRaw) => {
    if (!extrasRaw) return {};

    const parts = extrasRaw
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);

    const result = {};

    parts.forEach((part) => {
        const lower = part.toLowerCase();
        const detail = getErrorDetail(part);

        if (lower.includes(".email") || lower.includes("_email")) result.email = detail;
        else if (lower.includes(".firstname") || lower.includes("_firstname")) result.firstName = detail;
        else if (lower.includes(".lastname") || lower.includes("_lastname")) result.lastName = detail;
        else if (lower.includes(".customer") || lower.includes("_customer")) result.customer = detail;
        else if (lower.includes(".reseller") || lower.includes("_reseller")) result.reseller = detail;
        else if (lower.includes(".location") || lower.includes("_location")) result.location = detail;
        else if (lower.includes(".name") || lower.includes("_name")) result.name = detail;
        else if (lower.includes(".serialnumber") || lower.includes("_serialnumber")) result.serialNumber = detail;

        else result._general = (result._general ? result._general + " " : "") + detail;
    });

    return result;
};


export const handleGraphQLError = (error, setError, t) => {
    const gqlError = error?.graphQLErrors?.[0];
    if (!gqlError) {
        setError((prev) => ({...prev, general: t("common.serverError")}));
        return;
    }

    const reason = gqlError.extensions?.reason;
    const extrasRaw = gqlError.extensions?.extras || "";
    const parsed = parseExtrasErrors(extrasRaw);

    const hasFieldErrors = Object.keys(parsed).some((k) => k !== "_general");

    if (reason === "DATA_INTEGRITY_VIOLATION") {
        setError((prev) => ({
            ...prev,
            ...parsed,
            ...(hasFieldErrors ? {} : {general: t("common.dataIntegrityError")}),
        }));
    } else if (reason === "CONSTRAINT_VIOLATION") {
        setError((prev) => ({
            ...prev,
            ...parsed,
            ...(hasFieldErrors
                ? {}
                : {general: t("common.dataConstraintViolation")}),
        }));
    } else {
        setError((prev) => ({...prev, general: t("common.serverError")}));
    }
};
